import React, { useEffect, useState } from "react";
import { ShieldCheck, Clock } from "lucide-react";
import api from "../lib/api";

const BADGE = {
  Approved: "bg-emerald-100 text-emerald-700",
  Rejected: "bg-red-100 text-red-700",
  Pending: "bg-amber-100 text-amber-700",
};

export const ApprovalHistory = ({ entityType, entityId, refreshKey, emptyText }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!entityId) { setItems([]); return; }
    api.get(`/approvals/for/${entityType}/${entityId}`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [entityType, entityId, refreshKey]);

  if (!items.length) return emptyText ? <p className="text-xs text-slate-400 mt-2" data-testid="approval-history-empty">{emptyText}</p> : null;
  return (
    <div className="mt-5" data-testid="approval-history">
      <h3 className="font-semibold text-[#012a1e] text-sm flex items-center gap-1.5"><ShieldCheck size={15} className="text-[#004030]" /> Approval History</h3>
      <div className="space-y-2 mt-2">
        {items.map((a) => (
          <div key={a.id} className="rounded-lg border border-slate-200 p-2.5" data-testid={`approval-item-${a.id}`}>
            <div className="flex items-center justify-between gap-2">
              <p className="text-xs font-semibold text-[#012a1e]">{a.summary}</p>
              <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full shrink-0 ${BADGE[a.status] || "bg-slate-100 text-slate-600"}`}>{a.status}</span>
            </div>
            <p className="text-[10px] text-slate-400 mt-0.5">Requested by {a.requested_by_name} · {new Date(a.created_at).toLocaleString()}</p>
            <div className="mt-1.5 space-y-1">
              {(a.steps || []).map((s, i) => (
                <div key={i} className="flex items-center gap-1.5 text-[11px]">
                  {s.status === "Approved" ? <ShieldCheck size={12} className="text-emerald-600" /> : s.status === "Rejected" ? <span className="text-red-600">✕</span> : <Clock size={12} className="text-amber-500" />}
                  <span className="text-slate-600">{s.label}</span>
                  {s.approved_by_name && <span className="text-slate-400">· {s.status} by {s.approved_by_name}{s.at ? ` (${new Date(s.at).toLocaleDateString()})` : ""}{s.note ? ` — "${s.note}"` : ""}</span>}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
